import { FocusEvent, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as amplitude from '@amplitude/analytics-browser';

import TextArea from 'libs/design-system/src/components/TextArea';
import { Button } from '@unified-checkout/design-system';
import { TrashCan } from '@unified-checkout/design-system/icons/index';

import type { IAdvancedOptionsProps } from '@app/dashboard/types/innerLayout/payment_links/single_quick_link';
import { useLangStore } from '@app/dashboard/store/lang';
import { onFieldChangeHandler } from '@app/dashboard/utils/formValidations';
import { SINGLE_PAYMENTS_FIELDS } from '@app/dashboard/constants/payment-links/single-payments';
import {
  SINGLE_PAYMENT_LINKS_EVENTS,
  SINGLE_PAYMENT_LINKS_EVENTS_PARAMS,
} from '@app/dashboard/constants/tracking_events/payment_links/single';

const Description = ({
  fields,
  setFields,
}: Omit<IAdvancedOptionsProps, 'fullPageStatus'>) => {
  const { t } = useTranslation();
  const { lang } = useLangStore();
  const [restKey, setRestKey] = useState(0);

  const descriptionRef = useRef('');

  const description = fields[SINGLE_PAYMENTS_FIELDS.DESCRIPTION];

  const onChangeHandler = (value: string) => {
    onFieldChangeHandler(
      fields,
      setFields,
      SINGLE_PAYMENTS_FIELDS.DESCRIPTION,
      value,
      () => {}
    );
  };

  const onFocusHandler = (e: FocusEvent<HTMLTextAreaElement>) => {
    descriptionRef.current = e.target.value;
  };

  const onBlurHandler = (e: FocusEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;

    if (value && value !== descriptionRef.current) {
      amplitude.track(SINGLE_PAYMENT_LINKS_EVENTS.PRODUCT_DESCRIPTION_UPDATED, {
        [SINGLE_PAYMENT_LINKS_EVENTS_PARAMS.DESC_LENGTH]: value.length,
      });
    }
  };

  const handleDeleteDescription = () => {
    setRestKey((prev) => prev + 1);
    onChangeHandler('');
  };

  return (
    <div>
      <TextArea
        key={restKey}
        lang={lang}
        name={SINGLE_PAYMENTS_FIELDS.DESCRIPTION}
        label={t(
          'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.advancedOptions.labels.description'
        )}
        placeholder={t(
          'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.advancedOptions.placeholders.description'
        )}
        showCharactersCount
        maxLength={500}
        onChange={(e) => onChangeHandler(e.target.value)}
        value={description?.value}
        errorMessage={description?.errorMsg || ''}
        variant={description?.errorMsg ? 'error' : 'default'}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
      />
      {/* <Button
        size="md"
        text={t(
          'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.advancedOptions.actions.removeDescription'
        )}
        onClickHandler={handleDeleteDescription}
        variant="link"
        color="secondary"
        leadingIcon={TrashCan}
      /> */}
    </div>
  );
};

export default Description;
